var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBookIcon = function SvgBookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.375,
    d: "M34.833 26.504V7.394c0-1.9-1.551-3.31-3.435-3.151h-.095c-3.325.285-8.376 1.979-11.195 3.752l-.269.174c-.459.285-1.219.285-1.678 0l-.396-.237C14.947 6.174 9.912 4.496 6.587 4.227c-1.884-.158-3.42 1.267-3.42 3.15v19.127c0 1.52 1.235 2.945 2.755 3.135l.459.064c3.436.459 8.74 2.2 11.78 3.863l.063.032c.428.237 1.109.237 1.52 0 3.04-1.679 8.36-3.436 11.812-3.895l.522-.064c1.52-.19 2.755-1.615 2.755-3.135Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.375,
    d: "M19 8.693v23.75M12.27 13.443H8.709M13.458 18.193h-4.75",
    opacity: 0.4
  })));
};
export default SvgBookIcon;